import * as React from 'react';

import styled from 'styled-components';

import { motion, AnimatePresence } from 'framer-motion';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import ArrowIcon from '@components/basics/icons/arrow';
import BoxTitleHeader from '@components/layout/box-title-header';

interface EditableCollapsableBoxProps {
  className?: string;
  classNameInput?: string;
  placeholder?: string;
  value?: string;
  text: React.ReactNode;
  isOpened?: boolean;
  noBorderTop?: boolean;
  noBorderBottom?: boolean;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onChange?: (value: string) => void;
  onClose?: () => void;
  onToggle: (value: boolean) => void;
}

const EditableCollapsableBox: React.FC<EditableCollapsableBoxProps> = (
  props
) => {
  const [isOpen, setIsOpen] = React.useState(
    props.isOpened ? props.isOpened : false
  );

  const variants = {
    hidden: { opacity: 0, height: 0, marginTop: 0 },
    visible: { opacity: 1, height: '100%', marginTop: 30 },
  };

  const toggleOpen = () => {
    props.onToggle(!isOpen);
    setIsOpen(!isOpen);
  };

  return (
    <Box
      className={props.className}
      onClose={props.onClose}
      noBorderTop={props.noBorderTop}
      noBorderBottom={props.noBorderBottom}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <BoxTitleHeader
          value={props.value}
          title={props.value}
          placeholder={props.placeholder}
          text={props.text}
          onChange={props.onChange}
          isAvatar={true}
        />
        <ArrowWrapper onClick={() => toggleOpen()}>
          <ArrowIcon color="dark" up={!isOpen} />
        </ArrowWrapper>
      </Flex>
      <AnimatePresence>
        {isOpen ? (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={variants}
          >
            {props.children}
          </motion.div>
        ) : null}
      </AnimatePresence>
    </Box>
  );
};

export default styled(EditableCollapsableBox)``;

const ArrowWrapper = styled.div`
  cursor: pointer;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
`;
